<template>
  <div v-if="list?.length > 0" class="active-filters">
    <ui-ui-button
      v-for="(item, index) in list"
      :key="index"
      type="neutral"
      icon-after="close"
      font-class="body-m-regular"
      size-ico="16"
      size="medium"
      class="active-filter"
      @click="onClick(item)"
    >
      {{ item.name }}
    </ui-ui-button>
    <ui-ui-button
      size="medium"
      class="clear-btn"
      font-class="body-m-regular"
      @click="$emit('clearAll')"
    >
      Очистить
    </ui-ui-button>
  </div>
</template>

<script lang="ts">
import type { ActiveFilter } from '~/interfaces/app';

export default defineComponent({
  name: 'ActiveFilters',
  props: {
    list: {
      type: Array as () => ActiveFilter[],
      required: true,
    },
  },
  emits: ['cancel', 'clearAll'],
  setup(_, { emit }) {
    function onClick(item: ActiveFilter): void {
      emit('cancel', item);
    }

    return {
      onClick,
    };
  },
});
</script>

<style scoped lang="scss" src="./ActiveFiltersScss.scss" />
